import { clsx } from 'clsx';
import { useId, useState } from 'react';

import type { KeyboardEvent, ReactNode } from 'react';

import styles from './AccordionCard.module.css';

import { Icon } from 'components/Icon';

export interface AccordionCardProps {
  /** Clickable title (always visible). */
  title: ReactNode;
  /** Main content (hidden when expanded is false). */
  content: ReactNode;
  /** Indicator if Accordion should be expanded by default.*/
  expanded?: boolean;
}

export const AccordionCard = ({ title, content, expanded = false }: AccordionCardProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const accordionId = useId();

  const onKeyUp = (event: KeyboardEvent<HTMLDivElement>) => {
    const { code } = event;

    if (code === 'Enter' || code === 'Space') {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className={styles['accordion-card']}>
      <div
        className={styles['accordion-card__title']}
        id={accordionId}
        role="button"
        tabIndex={0}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyUp={onKeyUp}
        aria-expanded={isExpanded}
      >
        <Icon
          className={clsx(styles['accordion-card__title-icon'], {
            [styles['accordion-card__title-icon--expanded']]: isExpanded,
          })}
          name="CheveronLeft"
          size={16}
        />
        <h3>{title}</h3>
      </div>
      <div
        aria-labelledby={accordionId}
        className={clsx(styles['accordion-card__content'], {
          [styles['accordion-card__content--expanded']]: isExpanded,
        })}
      >
        {content}
      </div>
    </div>
  );
};
